import { useMediaQuery } from 'usehooks-ts';
/**
 * 移动端性能优化工具
 * 专门针对移动端的性能优化
 */

/**
 * 检测是否为移动设备
 */
export const isMobile = () => {
  return useMediaQuery('(max-width: 480px)');
};
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

/**
 * 禁用移动端的重型动画和效果 - 已禁用此功能
 */
export const disableHeavyEffects = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) return;

  // 保留AOS属性，让动画正常显示
  // const aosElements = document.querySelectorAll('[data-aos]');
  // aosElements.forEach((el) => {
  //   el.removeAttribute('data-aos');
  //   el.removeAttribute('data-aos-delay');
  //   el.removeAttribute('data-aos-offset');
  // });

  // console.log('📱 移动端：已禁用AOS动画属性');
};

/**
 * 优化移动端图片加载
 */
export const optimizeMobileImages = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) return;

  // 设置更激进的懒加载
  const images = document.querySelectorAll('img');
  images.forEach((img, index) => {
    // 移动端只立即加载前3张图片
    if (index >= 3) {
      img.loading = 'lazy';
      img.decoding = 'async';
    } else {
      img.loading = 'eager';
      img.fetchPriority = 'high';
    }
  });

  console.log('📱 移动端：图片懒加载已优化');
};

/**
 * 减少移动端的JavaScript执行
 */
export const reduceMobileJSExecution = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) return;

  // 延迟执行非关键脚本
  window.addEventListener('load', () => {
    setTimeout(() => {
      // 可以在这里延迟加载一些移动端不需要的功能
      console.log('📱 移动端：非关键脚本延迟执行');
    }, 2000);
  });
};

/**
 * 优化移动端字体加载
 */
export const optimizeMobileFonts = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) return;

  // 移动端只加载关键字体
  const style = document.createElement('style');
  style.textContent = `
    /* 移动端字体优化 */
    body {
      -webkit-text-size-adjust: 100%;
      text-rendering: optimizeSpeed; /* 移动端优先速度而非质量 */
    }
    
    /* 使用系统字体作为fallback */
    * {
      font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 
        'Segoe UI', 'Roboto', sans-serif;
    }
  `;
  document.head.appendChild(style);

  console.log('📱 移动端：字体加载已优化');
};

/**
 * 移动端预连接优化
 */
export const addMobilePreconnects = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) return;

  // 预连接到图片服务器
  const preconnects = ['https://strapi-upload-images-prod.s3.eu-west-2.amazonaws.com'];

  preconnects.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = url;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });

  console.log('📱 移动端：预连接已添加');
};

/**
 * 初始化移动端优化
 */
export const initMobileOptimization = () => {
  if (typeof window === 'undefined') return;
  if (!isMobileDevice()) {
    console.log('💻 桌面端设备，跳过移动端优化');
    return;
  }

  console.log('📱 启动移动端专用优化...');

  try {
    // 立即执行的优化
    addMobilePreconnects();
    optimizeMobileFonts();

    // DOM加载后执行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        disableHeavyEffects();
        optimizeMobileImages();
      });
    } else {
      disableHeavyEffects();
      optimizeMobileImages();
    }

    // 页面加载后执行
    reduceMobileJSExecution();

    console.log('✅ 移动端优化已启动');
  } catch (error) {
    console.warn('移动端优化失败:', error);
  }
};
